module.exports = __webpack_public_path__ + "static/media/score-big.5ee30899.svg";